/**
 * Column Control (Meteor)
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';
import { initAnimations } from '@RockwellAutomation/rockwell-meteor';
const componentName = 'column-control-meteor';

export class ColumnControlMeteor extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body
    };

    // Remove empty columns when horizontal align is selected (so :empty CSS pseudo-class works)
    removeWhitespace() {
        if (!this.element.classList.contains('px-grid--center-content')) return;

        const columnEls = this.element.querySelectorAll(':scope > div[class*="grid__column"]');
        for (let i = 0; i < columnEls.length; i += 1) {
            const content = columnEls[i].querySelector('.grid-column-content');
            if (content) {
                if (content.innerHTML.trim().length === 0) {
                    columnEls[i].innerText = '';
                }
            } else if (columnEls[i].innerHTML.trim().length === 0) {
                columnEls[i].innerText = '';
            }
        }
    }

    /**
     * Initialize Component
     */
    init() {
        this.removeWhitespace();
        if (!isEditModeFooter()) {
            try {
                initAnimations();
            } catch (error) {
                // Suppressing error when already initialized
            }
        }
    }
}

registerComponent(`.${componentName}`, ColumnControlMeteor);
